import(/* webpackMode: "eager" */ "/app/apps/no-ga/src/app/[locale]/(site)/angra-kop/page.tsx");
